import { Pipe, PipeTransform } from '@angular/core';
import { IField } from '../../document-type-settings.dto';

@Pipe({
  name: 'extractSelectedFields'
})
export class ExtractSelectedFieldsPipe implements PipeTransform {

  transform(fields: IField[]): number[] {
    return fields.map(field => field.meta_data_id) ?? [];
  }

}
